import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "../supabase/client";

import { useLogin } from "../context/LoginContext";
import { useProcess } from "../context/ProcessContext";

import TitleBox from "../components/common/TitleBox";
import Button from "../components/common/Button";
import ContainerBox from "../components/common/ContainerBox";
import TableData from "../components/common/TableData";
import Modal from "../components/common/Modal";
import {
  IconEdit,
  IconElipsis,
  IconPdf,
  IconPlus,
  IconTrash,
} from "../components/icons/Icons";
import ProcessForm from "../components/forms/ProcessForm";
import InputCheckFilter from "../components/common/InputCheckFilter";
import DropdownFilter from "../components/common/DropdownFilter";
import Form from "../components/calendar/Form";
// import ButtonExport from "../components/common/ButtonExport";

// import { useProcesos } from '../hooks/useProcesos'
// import { useModalidades } from '../hooks/useModalidades'
// import { useTipoProceso } from '../hooks/useTipoProceso'

const ProcesosPage = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalOptions, setModalOptions] = useState(false);
  const [modalAudiencias, setModalAudiencias] = useState(false);
  const [modalFormAudiencia, setModalFormAudiencia] = useState(false);
  const [modalCartas, setModalCartas] = useState(false);
  const [idData, setIdData] = useState(null);
  const [audiencias, setAudiencias] = useState([]);
  const [audiencia, setAudiencia] = useState([]);
  const [cartas, setCartas] = useState([]);
  const [carta, setCarta] = useState([]);
  const [filtro, setFiltro] = useState({
    taccia: false,
    daccia: false,
    reccia: false,
    jrdccia: false,
  });

  const navigate = useNavigate();
  const { user } = useLogin();
  const { processes, getProcesses, modal, getModal } = useProcess();
console.log(user)
  useEffect(() => {
    if (user !== null) {
      navigate("/procesos");
    }
    getProcesses();
  }, [user]);

  const columns = [
    {
      header: "#",
      cell: ({ cell }) => {
        const { row } = cell;
        return <div>{row.index + 1}</div>;
      },
    },
    {
      header: "Número expediente",
      accessorFn: (row) =>
        `${row.num_process}-${row.anio_process}-${row.class_process.name}`,
    },
    {
      header: "Demandante",
      accessorFn: (row) =>
        row.demanding !== null ? `${row.demanding.name}` : "",
    },
    {
      header: "Demandado",
      accessorFn: (row) =>
        row.defendant !== null ? `${row.defendant.name}` : "",
    },
    {
      header: "Contraseña",
      accessorKey: "password",
    },
    {
      header: "Estado",
      accessorFn: (row) => `${row.status_process.name}`,
    },
    {
      header: "Fecha de creación",
      accessorFn: (row) => {
        const date = new Date(row.date_created);
        return `${date.toLocaleDateString()}`;
      },
    },
    {
      header: "Acciones",
      cell: ({ cell }) => {
        const id = cell.row.original.id;
        return (
          <div className="flex items-center">
            <button
              className="bg-primary/80 hover:bg-primary border border-primary/80 text-xs text-white w-8 h-8 flex items-center justify-center rounded-sm"
              title="Más"
              onClick={async () => {
                setModalOptions(true);
                // await getAudiencia(id);
                // openModal();
                setIdData(id);
              }}
            >
              <IconElipsis className="w-4" />
            </button>
            <button
              className="bg-warning/80 hover:bg-warning border border-warning/80 text-xs text-black/50 w-8 h-8 flex items-center justify-center rounded-sm"
              title="Editar"
              onClick={async () => {
                // await getAudiencia(id);
                openModal();
                // setIdData(id);
              }}
            >
              <IconEdit className="w-4" />
            </button>
            <button
              className="bg-danger/90 hover:bg-danger border border-danger/90 text-xs text-white w-8 h-8 flex items-center justify-center rounded-sm"
              title="Eliminar"
              onClick={openModal}
            >
              <IconTrash ButtonclassName="w-4" />
            </button>
          </div>
        );
      },
    },
  ];

  const columnsAudiencias = [
    {
      header: "#",
      cell: ({ cell }) => {
        const { row } = cell;
        return <div>{row.index + 1}</div>;
      },
    },
    {
      header: "Expediente",
      accessorFn: (row) =>
        row.process !== null
          ? `${row.process.num_process}-${row.process.anio_process}-${row.process.class_process.name}`
          : "",
    },
    {
      header: "Fecha",
      accessorKey: "date",
    },
    {
      header: "Detalle",
      accessorKey: "title",
    },
    {
      header: "Secretario",
      accessorFn: (row) =>
        row.process !== null
          ? `${row.secretaries.users.first_name} ${row.secretaries.users.last_name}`
          : "",
    },
    {
      header: "Acciones",
      cell: ({ cell }) => {
        const id = cell.row.original.id;
        return (
          <div className="flex items-center">
            <button
              className="bg-warning/80 hover:bg-warning border border-warning/80 text-xs text-black/50 px-2 py-1 rounded-sm"
              title="Editar"
              onClick={async () => {
                await getAudiencia(id);
                setModalFormAudiencia(true);
                // setIdData(id);
              }}
            >
              <IconEdit className="w-4" />
            </button>
            <button
              className="bg-danger/90 hover:bg-danger border border-danger/90 text-xs text-white px-2 py-1 rounded-sm"
              title="Eliminar"
              onClick={openModal}
            >
              <IconTrash className="w-4" />
            </button>
          </div>
        );
      },
    },
  ];

  const columnsCartas = [
    {
      header: "Código",
      accessorKey: "code",
    },
    {
      header: "Remitente",
      accessorFn: (row) =>
        `${row.secretaries.users.first_name} ${row.secretaries.users.last_name}`,
    },
    {
      header: "Destinatario",
      accessorFn: (row) => `${row.persons.name}`,
    },
    {
      header: "Detalle",
      accessorKey: "detail",
    },
    {
      header: "F. elabo.",
      accessorFn: (row) => `${row.created_at.split("T")[0]}`,
    },
    {
      header: "F. envío",
      accessorFn: (row) => `${row.sending_date.split("T")[0]}`,
    },
    {
      header: "F. noti.",
      accessorFn: (row) => `${row.notification_date.split("T")[0]}`,
    },
    {
      header: "Secretario",
      accessorFn: (row) => `${row.users.first_name} ${row.users.last_name}`,
    },
    {
      header: "Visualiza",
      cell: ({ cell }) => {
        const display = cell.row.original.display;
        const id = cell.row.original.id;
        return (
          <button
            className={`flex items-center justify-center text-xs capitalize text-white rounded-full w-14 h-5 ${
              display === true ? "bg-success " : "bg-danger/40"
            }`}
            type="button"
            onClick={() => handleActiveChange(id, display)}
          >
            {display ? "Activo" : "Inactivo"}
          </button>
        );
      },
    },
    {
      header: "Acciones",
      cell: ({ cell }) => {
        const id = cell.row.original.id;
        const file = cell.row.original.file;
        return (
          <div className="flex items-center">
            <a
              href={"cv/" + file}
              target="_blank"
              rel="noreferrer"
              className={`${
                file !== null
                  ? `bg-primary/80 hover:bg-primary border-primary/80`
                  : `bg-secondary/30 border-secondary/10 pointer-events-none cursor-none`
              } border text-xs text-white px-2 py-1 rounded-sm`}
              title="Archivo"
              alt={file}
            >
              <IconPdf  className="w-4" />
            </a>
            <button
              className="bg-warning/80 hover:bg-warning border border-warning/80 text-xs text-black/50 px-2 py-1 rounded-sm"
              title="Editar"
              onClick={() => openModal(id)}
            >
              <IconEdit className="w-4" />
            </button>
            <button
              className="bg-danger/90 hover:bg-danger border border-danger/90 text-xs text-white px-2 py-1 rounded-sm"
              title="Eliminar"
              onClick={openModal}
            >
              <IconTrash className="w-4" />
            </button>
          </div>
        );
      },
    },
  ];

  const getAudiencias = async (idData) => {
    const { data, error } = await supabase
      .from("audiences")
      .select(
        `
            *,
            process (
                num_process,
                anio_process,   
                class_process(
                    name
                )
            ),
            secretaries (
                users (
                    first_name,
                    last_name
                )
            )
            `
      )
      .eq("id_process", idData);
    if (error) console.log("error", error);
    setAudiencias(data);
  };

  const getAudiencia = async (id) => {
    const { data, error } = await supabase
      .from("audiences")
      .select()
      .eq("id", id)
      .single();
    if (error) {
      console.error("Error:", error);
      return;
    }
    const date = data.date + " " + data.start;
    const end = data.date + " " + data.end;
    const formattedEvents = {
      ...data,
      start: date,
      end: end,
    };
    setAudiencia(formattedEvents);
  };

  const getCartas = async (idData) => {
    const { data, error } = await supabase
      .from("letters")
      .select(
        `
                *,
                process (
                    num_process,
                    anio_process,
                    class_process(
                        name
                    )
                ),
                secretaries (
                    users (
                        first_name,
                        last_name
                    )
                ),
                users(
                    first_name,
                    last_name
                ),
                persons (
                    name
                )
                `
      )
      .eq("process_id", idData);
    if (error) console.log("error", error);
    setCartas(data);
  };

  const handleActiveChange = async (id, status) => {
    const { error } = await supabase
      .from("letters")
      .update({
        display: !status,
      })
      .eq("id", id);
    if (error) console.log("error", error);
    getCartas();
  };

  const openModal = (id = null) => {
    setIsModalOpen(true);
    setIdData(id);
    getModal();
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleCheckboxChange = (event) => {
    const { name, checked } = event.target;
    setFiltro({ ...filtro, [name]: checked });
  };

  const usuariosFiltrados = processes.filter((process) => {
    if (filtro.taccia && process.class_process.name !== "TA-CCIA") {
      return false;
    }
    if (filtro.daccia && process.class_process.name !== "DA-CCIA") {
      return false;
    }
    if (filtro.reccia && process.class_process.name !== "RE-CCIA") {
      return false;
    }
    if (filtro.jrdccia && process.class_process.name !== "JRD-CCIA") {
      return false;
    }
    return true;
  });

  return (
    <div className="pb-5">
      <TitleBox title="Relación de procesos" />
      <ContainerBox>
        <Button value="Nuevo" openModal={() => openModal()}>
          <IconPlus className="w-4" />
        </Button>
        <TableData columns={columns} data={usuariosFiltrados}>
          <div className="flex items-center gap-2">
            <DropdownFilter width={"w-[400px]"}>
              <div className="grid grid-cols-3 gap-2">
                <ul className="p-2 space-y-1">
                  <InputCheckFilter
                    name="taccia"
                    checked={filtro.taccia}
                    onChange={handleCheckboxChange}
                    text={"TA-CCIA"}
                  />
                  <InputCheckFilter
                    name="daccia"
                    checked={filtro.daccia}
                    onChange={handleCheckboxChange}
                    text={"DA-CCIA"}
                  />
                </ul>
                <ul className="p-2 space-y-1">
                  <InputCheckFilter
                    name="reccia"
                    checked={filtro.reccia}
                    onChange={handleCheckboxChange}
                    text={"RE-CCIA"}
                  />
                  <InputCheckFilter
                    name="jrdccia"
                    checked={filtro.jrdccia}
                    onChange={handleCheckboxChange}
                    text={"JRD-CCIA"}
                  />
                </ul>
              </div>
            </DropdownFilter>
            {/* <ButtonExport onClick={() => handleExportData()} /> */}
          </div>
        </TableData>
      </ContainerBox>
      <Modal
        isOpen={isModalOpen}
        onClose={closeModal}
        isModal={modal}
        title={"Nuevo registro"}
      >
        <ProcessForm idData={idData} />
      </Modal>
      <Modal
        isOpen={modalOptions}
        onClose={() => setModalOptions(false)}
        title={"Opciones adicionales"}
        modalSize="md"
      >
        <div className="h-full overscroll-contain w-full flex flex-wrap justify-center md:flex-row items-center gap-4">
          <button
            className="text-primary border border-primary hover:bg-primary hover:text-white transition-colors duration-300 focus:outline-none font-light rounded-md text-sm px-4 py-1 text-center inline-flex items-center gap-1"
            type="button"
            onClick={async () => {
              await getAudiencias(idData);
              setModalAudiencias(true);
              setModalOptions(false);
            }}
          >
            Audiencias
          </button>
          <button
            className="text-primary border border-primary hover:bg-primary hover:text-white transition-colors duration-300 focus:outline-none font-light rounded-md text-sm px-4 py-1 text-center inline-flex items-center gap-1"
            type="button"
            onClick={async () => {
              await getCartas(idData);
              setModalCartas(true);
              setModalOptions(false);
            }}
          >
            Cartas
          </button>
          <button
            className="text-primary border border-primary hover:bg-primary hover:text-white transition-colors duration-300 focus:outline-none font-light rounded-md text-sm px-4 py-1 text-center inline-flex items-center gap-1"
            type="button"
            onClick={() => console.log(idData)}
          >
            Escritos
          </button>
          <button
            className="text-primary border border-primary hover:bg-primary hover:text-white transition-colors duration-300 focus:outline-none font-light rounded-md text-sm px-4 py-1 text-center inline-flex items-center gap-1"
            type="button"
            onClick={() => console.log(idData)}
          >
            Peticiones
          </button>
          <button
            className="text-primary border border-primary hover:bg-primary hover:text-white transition-colors duration-300 focus:outline-none font-light rounded-md text-sm px-4 py-1 text-center inline-flex items-center gap-1"
            type="button"
            onClick={() => console.log(idData)}
          >
            Resoluciones
          </button>
        </div>
      </Modal>
      <Modal
        isOpen={modalAudiencias}
        onClose={() => setModalAudiencias(false)}
        title={"Audiencias"}
      >
        <Button value="Nuevo" openModal={() => setModalFormAudiencia(true)}>
          <IconPlus className="w-4" />
        </Button>
        <TableData columns={columnsAudiencias} data={audiencias} />
      </Modal>
      <Modal
        isOpen={modalFormAudiencia}
        onClose={() => setModalFormAudiencia(false)}
        title="Nuevo registro"
      >
        <div className="h-full overscroll-contain w-full flex flex-col md:flex-row items-center gap-4">
          <Form
            onClose={() => setModalFormAudiencia(false)}
            dataEvent={audiencia}
          />
        </div>
      </Modal>
      <Modal
        isOpen={modalCartas}
        onClose={() => setModalCartas(false)}
        title={"Cartas"}
      >
        <Button value="Nuevo" openModal={() => setModalFormAudiencia(true)}>
          <IconPlus className="w-4" />
        </Button>
        <TableData columns={columnsCartas} data={cartas} />
      </Modal>
    </div>
  );
};

export default ProcesosPage;
